class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0 || $('.js-featureSwiper').length > 0){
      this.event();
    }
  }
  event(){
    this.featureSwiper();
  }
  featureSwiper(){
    const init = () => {
      const el = document.querySelector('.js-featureSwiper');
      if (!el || typeof Swiper === 'undefined' || el.swiper) return;

      new Swiper(el, {
        effect: 'cards',
        grabCursor: true,
        rewind: true,
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        cardsEffect: {
          perSlideOffset: 0.75,
          perSlideRotate: 5,
          rotate: true,
          slideShadows: false,
        },
      });
    };

    $(init);
    $(window).on('load', init);
  }
}
